import "./BannerSectionB2C.scss";
import { useNavigate } from "react-router-dom";

const BannerSectionB2C = (props) => {
  let navigate = useNavigate();
  return (
    <section className="bannersection overflow-hidden">
      <div className="container">
        <div className="col-12 col-lg-6 leftsec">
          <h1>Elevate your real estate game.</h1>
          <p>
            Our premium subscription plans offer an exclusive gateway to
            unparalleled learning and growth opportunities.
          </p>
          <p>
            Invest in your success with our premium subscription plans. Choose
            the plan that suits your goals and accelerate your journey to real
            estate excellence.
          </p>

          <button type="button" className="default-btn" onClick={()=>navigate("/subscription")}>
            Explore subscriptions
          </button>
        </div>
        <div className="col-12 col-lg-6 rightsec"></div>
      </div>
    </section>
  );
};
export default BannerSectionB2C;
